import styled from "styled-components";
const Main = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 991px) {
    max-width: 960px;
  }
  @media (max-width: 767px) {
    max-width: 720px;
  }
  @media (max-width: 575px) {
    max-width: 540px;
  }
`;
export default Main;
